import React from 'react';
import { Row, Col, Typography, Button } from 'antd';
import { LoginOutlined, LockOutlined } from '@ant-design/icons';

import * as Config from '../../../Config';

const { Text, Title } = Typography;

const ContentFinalCall = () => {
    return (
        <div>
            <Row align='middle' style={{ padding: '4rem', align: 'center' }}>
                <Col xs={24}>
                    <Col align='center'>
                        <Title style={{ fontSize: '32px' }}>
                            Join now and create a healthier, happier mind
                        </Title>
                        <Text style={{ fontSize: '20px' }}>
                            We're more than just a journal, or a diary; we're
                            your own motivational coach and happiness trainer.
                            Let's embark on a fabulous journey of
                            self-improvement today.
                        </Text>
                    </Col>
                    <Col
                        xs={24}
                        align='center'
                        style={{ padding: '2rem 0', textAlign: 'center' }}
                    >
                        <Button
                            // block
                            type='primary'
                            size='large'
                            icon={<LoginOutlined />}
                            onClick={() => {
                                const returnTo = window.location.origin;
                                window.location.href = `https://auth.rajchandra.me/login?returnTo=${encodeURIComponent(returnTo)}`;
                            }}
                        >
                            Login to your Account
                        </Button>
                    </Col>
                    <Col align='center'>
                        <LockOutlined /> Your data is protected with us.
                    </Col>
                </Col>
            </Row>
        </div>
    );
};

export default ContentFinalCall;
